export default __webpack_public_path__ + "static/media/bottomPreview.bf26313b.png";